export class ParametrosPaginacao {
	pagina?: number;
	itemsPorPagina?: number;

	constructor(pagina?: number, itemsPorPagina?: number) {
		this.pagina = pagina;
		this.itemsPorPagina = itemsPorPagina;
	}
}
